export const mapUserToLocations = (user) => {
    if (!user) return [];
    return user?.data?.data?.clinic?.locations;
}
export const mapUserToClinic = (user) => {
    if (!user) return;
    return user?.data?.data?.clinic;
}
export const mapLocationToURLSearchParams = (location)=>{
    return new URLSearchParams(location?.search);
}
export const getSearchParamFromLocation = (key, location)=> {
    const queryParams = mapLocationToURLSearchParams(location);
    return queryParams.get(key);
}